import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const PurchaseOrderListPage = () => {
    const navigate = useNavigate();
    const [purchaseOrders, setPurchaseOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filters, setFilters] = useState({
        search: '',
        status: '',
        startDate: '',
        endDate: ''
    });

    useEffect(() => {
        loadPurchaseOrders();
    }, []);

    const loadPurchaseOrders = async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await fetch('https://medi-panel.cloud/api/purchase-orders/recent');
            if (response.ok) {
                const pos = await response.json();
                setPurchaseOrders(pos);
            } else {
                throw new Error('Purchase Order listesi getirilemedi');
            }
        } catch (err) {
            console.error('❌ PO listesi yükleme hatası:', err);
            setError('Purchase Order listesi yüklenirken hata oluştu: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleBackToOrders = () => {
        navigate('/orders');
    };



    const handleDownloadPO = async (poId, poNumber) => {
        try {
            console.log('🚀 HTML doküman indiriliyor...');

            const response = await fetch(`https://medi-panel.cloud/api/purchase-orders/${poId}/pdf`);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // HTML content olarak al
            const htmlContent = await response.text();
            console.log('📦 HTML içerik alındı:', htmlContent.length, 'karakter');

            // HTML'i blob olarak kaydet
            const blob = new Blob([htmlContent], { type: 'text/html' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${poNumber}.html`; // 🔥 .html uzantılı
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            console.log('✅ HTML indirme başarılı!');

        } catch (error) {
            console.error('❌ İndirme hatası:', error);
            alert('Doküman indirilemedi: ' + error.message);
        }
    };


    const handleViewPO = (po) => {
        // 🔥 PO Detail Modal'ını aç
        console.log('PO görüntüle:', po.poNumber);
        alert(`PO Görüntüleme: ${po.poNumber}\n\nBu özellik yakında eklenecek!`);

        // İLERİDE: Burada PO detail modal'ı açılacak
        // setSelectedPO(po);
    };


    const getStatusColor = (status) => {
        const colors = {
            'generated': '#4caf50',
            'draft': '#ff9800',
            'sent': '#2196f3',
            'approved': '#9c27b0',
            'cancelled': '#f44336'
        };
        return colors[status] || '#666';
    };

    const getStatusText = (status) => {
        const texts = {
            'generated': 'Oluşturuldu',
            'draft': 'Taslak',
            'sent': 'Gönderildi',
            'approved': 'Onaylandı',
            'cancelled': 'İptal Edildi'
        };
        return texts[status] || status;
    };

    if (loading) {
        return (
            <div style={{ padding: '2rem', textAlign: 'center' }}>
                <div style={{ fontSize: '1.2rem', color: '#666' }}>⏳ Purchase Order listesi yükleniyor...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ padding: '2rem', textAlign: 'center' }}>
                <div style={{ color: '#f44336', marginBottom: '1rem' }}>❌ {error}</div>
                <button
                    onClick={loadPurchaseOrders}
                    style={{
                        padding: '0.5rem 1rem',
                        backgroundColor: '#1976d2',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                >
                    🔄 Tekrar Dene
                </button>
            </div>
        );
    }

    return (
        <div style={{ padding: '1rem', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
            {/* HEADER */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem',
                flexWrap: 'wrap',
                gap: '1rem'
            }}>
                <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem' }}>
                        <button
                            onClick={handleBackToOrders}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#1976d2',
                                fontSize: '1.5rem',
                                cursor: 'pointer',
                                padding: 0
                            }}
                        >
                            ←
                        </button>
                        <h1 style={{ margin: 0, color: '#9c27b0', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            📄 Purchase Order'lar
                            <span style={{
                                fontSize: '0.8rem',
                                backgroundColor: '#e1bee7',
                                color: '#9c27b0',
                                padding: '0.2rem 0.5rem',
                                borderRadius: '12px'
                            }}>
                                {purchaseOrders.length} adet
                            </span>
                        </h1>
                    </div>
                    <p style={{ margin: 0, color: '#666', fontSize: '0.9rem' }}>
                        Tüm oluşturulmuş purchase order'ların listesi
                    </p>
                </div>

                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                    <button
                        onClick={loadPurchaseOrders}
                        style={{
                            padding: '0.5rem 1rem',
                            backgroundColor: '#1976d2',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem'
                        }}
                    >
                        🔄 Yenile
                    </button>

                    <button
                        onClick={handleBackToOrders}
                        style={{
                            padding: '0.5rem 1rem',
                            backgroundColor: '#ff9800',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem'
                        }}
                    >
                        📦 Siparişlere Dön
                    </button>
                </div>
            </div>

            {/* PO LIST */}
            <div>
                {purchaseOrders.length === 0 ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '3rem',
                        color: '#666',
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        border: '2px dashed #ddd'
                    }}>
                        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📭</div>
                        <h3>Henüz purchase order bulunmuyor</h3>
                        <p>İlk purchase order'ı oluşturmak için sipariş detay sayfasına gidin.</p>
                        <button
                            onClick={handleBackToOrders}
                            style={{
                                padding: '0.5rem 1rem',
                                backgroundColor: '#1976d2',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                marginTop: '1rem'
                            }}
                        >
                            📦 Siparişlere Git
                        </button>
                    </div>
                ) : (
                    purchaseOrders.map(po => (
                        <div
                            key={po.id}
                            style={{
                                backgroundColor: 'white',
                                border: '1px solid #e0e0e0',
                                padding: '1rem',
                                marginBottom: '1rem',
                                borderRadius: '8px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                marginBottom: '0.5rem',
                                flexWrap: 'wrap',
                                gap: '0.5rem'
                            }}>
                                <div style={{ flex: 1 }}>
                                    <h3 style={{ margin: '0 0 0.25rem 0', color: '#333' }}>
                                        {po.poNumber}
                                    </h3>
                                    <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
                                        📦 Sipariş: #{po.order?.orderNumber} - {po.order?.customerFirstName} {po.order?.customerLastName}
                                    </p>
                                    <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.8rem', color: '#999' }}>
                                        📧 {po.order?.customerEmail}
                                    </p>
                                </div>

                                <div style={{ textAlign: 'right' }}>
                                    <span
                                        style={{
                                            backgroundColor: getStatusColor(po.status),
                                            color: 'white',
                                            padding: '0.3rem 0.8rem',
                                            borderRadius: '12px',
                                            fontSize: '0.8rem',
                                            fontWeight: 'bold',
                                            display: 'inline-block',
                                            marginBottom: '0.5rem'
                                        }}
                                    >
                                        {getStatusText(po.status)}
                                    </span>
                                    <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.8rem', color: '#666' }}>
                                        📅 {new Date(po.createdAt).toLocaleDateString('tr-TR', {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </p>
                                </div>
                            </div>

                            {/* ACTION BUTTONS */}
                            <div style={{
                                display: 'flex',
                                gap: '0.5rem',
                                justifyContent: 'flex-end',
                                marginTop: '1rem',
                                paddingTop: '1rem',
                                borderTop: '1px solid #f0f0f0'
                            }}>
                                {/* 🔥 YENİ: PO GÖRÜNTÜLE BUTONU */}
                                <button
                                    onClick={() => handleViewPO(po)}
                                    style={{
                                        padding: '0.4rem 0.8rem',
                                        backgroundColor: '#2196f3',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '0.8rem',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    📊 PO Görüntüle
                                </button>

                                <button
                                    onClick={() => navigate(`/orders/${po.orderId}`)}
                                    style={{
                                        padding: '0.4rem 0.8rem',
                                        backgroundColor: '#ff9800',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '0.8rem',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    📦 Siparişe Git
                                </button>
                                <button
                                    onClick={() => handleDownloadPO(po.id, po.poNumber)}
                                    style={{
                                        padding: '0.4rem 0.8rem',
                                        backgroundColor: '#4caf50',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '0.8rem',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    ⬇️ PDF İndir
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default PurchaseOrderListPage;